<template>
  <section class="portal-help pa-4 px-md-6">
    <portal-page-header
      :title="portalScreenTitle || 'Ayuda del portal'"
      :subtitle="portalScreenSubtitle || (!hasHelpHtml ? 'No hay contenido de ayuda configurado para el portal.' : '')"
    />

    <div class="portal-help__content bg-surface">
      <div v-if="hasHelpHtml" class="portal-help__html" v-html="helpHtml" />

      <div v-else class="portal-help__fallback">
        <v-icon :icon="helpIcon" size="44" color="primary" class="mb-3" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import enums from '../../../utils/enums'
import PortalPageHeader from '../../../components/layout/PortalPageHeader.vue'
import portalScreenSubtitleMixin from '../../../mixins/portalScreenSubtitle'

export default {
  name: 'PortalHelp',
  components: { PortalPageHeader },
  mixins: [portalScreenSubtitleMixin],
  data() {
    return {
      helpIcon: enums.icons.HELP_OUTLINE,
    }
  },
  computed: {
    ...mapState('portalConfig', ['hospitalConfig']),
    helpHtml() {
      return String(this.hospitalConfig?.helpTextPortal || '').trim()
    },
    hasHelpHtml() {
      return this.helpHtml.length > 0
    },
  },
}
</script>

<style scoped>
.portal-help {
  width: 100%;
}
.portal-help__content {
  width: min(100%, 980px);
  margin: 0 auto;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}
.portal-help__html {
  padding: 24px;
}
.portal-help__fallback {
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  text-align: center;
}
.portal-help__html :deep(table) {
  max-width: 100%;
}
.portal-help__html :deep(img) {
  max-width: 100%;
  height: auto;
}
.portal-help__html :deep(p:last-child) {
  margin-bottom: 0;
}
</style>
